import { AlertDialog, Text } from "dssp-ui-lib";
import { UseJsxT, useStringT } from "@/functions/i18n/LanguageFormatter";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { triggerAnalytics } from "./analyticsSession";

interface SessionExpiredDialogProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    onLogout: () => void;
}

export function SessionExpiredDialog({ open, setOpen, onLogout }: SessionExpiredDialogProps) {
    const { i18n } = useTranslation("stitcher");
    const title = useStringT("ui.session.expired.title");
    const gotItButton = useStringT("ui.session.expired.button");

    useEffect(() => {
        if (open) {
            triggerAnalytics("Session expired", i18n.language)
        }
    }, [open]);

    return (
        <AlertDialog
            iconType={"system-downtime"}
            isOpen={open}
            setOpen={setOpen}
            onClick={onLogout}
            width={"min(500px, calc(100vw - 32px))"}
            title={title}
            btnLabel={gotItButton}
            isHTMLContent
            htmlMessage={
                <>
                    <Text
                        size={"sm"}
                        className={
                            "rds-text-[14px] rds-leading-[22px] md:rds-text-[16px] md:rds-leading-[26px] rds-text-neutral-100 rds-text-center"
                        }
                    >
                        <UseJsxT k={"ui.session.expired.message"} />
                        <br />
                        <UseJsxT k={"ui.session.expired.message2"} />
                    </Text>
                </>
            }
        />
    );
}
